import React from "react";

const HiddenInput = React.memo(({ name, value }) => (
  <input name={name} type="hidden" value={value} />
));

export default React.memo(HiddenInput);
